export default __webpack_public_path__ + "static/media/Paint-banner.07da9d09.jpg";